export const projectsName = {
  firstName: 'Nombre del proyecto',

  secondName: 'Nombre del proyecto',
};

export const portfolioText =
  'Una vez que el ayuntamiento haya otorgado un certificado de finalización a la casa y haya sido aprobada por su agente, puede recostarse en el sofá cuidadosamente elegido y admirar su maravilloso nuevo hogar. El período de garantía de defectos, en el que el contratista está obligado a reparar cualquier inconveniente, durará aproximadamente 12 meses.';